import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import DeleteConfirmationOverlay from '@/components/DeleteConfirmationOverlay'
import PaginationTable from '@/components/PaginationTable'

import columns from './columns'
import messages from './messages'

const sortOrders = { ascending: 'ASC', descending: 'DESC' }

function UsersByRoleTable(props: any) {
  const intl = useIntl()

  const [state, _setState] = useState({
    isDeleting: false
  })
  const setState = (update: Partial<Parameters<typeof _setState>[0]>) => {
    return _setState(state => ({ ...state, ...(typeof update === 'function' ? update(state) : update) }))
  }

  // componentDidMount
  useEffect(() => {
    // @ts-expect-error
    props.loadSpaceMembersByRole(1, props.sortBy, sortOrders[props.direction || ''].toLowerCase())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /**
   * Remove the current member from the selected role
   */
  const onRemoveRole = () => {
    setState({ isDeleting: false })
    // @ts-expect-error
    props.removeRole(state.memberToDelete)
  }

  /**
   * Show a confirm delete dialog for the user id (guid)
   *
   * @param userId the user's guid
   */
  const showConfirmDelete = (userId: any) => {
    setState({ isDeleting: true, memberToDelete: userId })
  }

  /**
   * User decided to cancel the delete operation
   */
  const onCancelDelete = () => {
    setState({ isDeleting: false, memberToDelete: '' })
  }

  /**
   * User used one of the paging features of the table - load new results
   *
   * @param page the current page number
   * @param sortBy the filed to sort by
   * @param direction the direction of the sort
   */
  const onPaginateSelect = (page: any, sortBy: any, direction: any) => {
    props.loadSpaceMembersByRole(page, sortBy, direction)
  }

  const { sortBy, direction } = props
  const sortingColumn =
    // @ts-expect-error
    sortBy && direction ? { [sortBy]: { direction: sortOrders[direction || ''].toLowerCase() } } : {}
  return (
    <div>
      {props.members.length > 0 ? (
        <PaginationTable
          columns={columns({
            intl: intl,
            onDelete: showConfirmDelete
          })}
          pagination={{
            count: props.memberCount,
            startIndex: props.startIndex,
            perPage: props.perPage
          }}
          onPaginateSelect={onPaginateSelect}
          rows={props.members}
          rowItemType={<FormattedMessage {...messages.members} />}
          rowKey="id"
          sortingColumn={sortingColumn}
        />
      ) : (
        <p className="no-members flex-center">
          <FormattedMessage {...messages.noUsers} />
        </p>
      )}

      {!!state.isDeleting && (
        <DeleteConfirmationOverlay
          onConfirm={onRemoveRole}
          onCancel={onCancelDelete}
          message={<FormattedMessage {...messages.confirmDelete} />}
          subMessage={<FormattedMessage {...messages.confirmDeleteSubMessage} />}
        />
      )}
    </div>
  )
}

UsersByRoleTable.propTypes = {
  memberCount: PropTypes.number,
  members: PropTypes.array,
  isLoading: PropTypes.bool,
  sortBy: PropTypes.string,
  direction: PropTypes.string,
  perPage: PropTypes.number.isRequired,
  startIndex: PropTypes.number.isRequired,

  loadSpaceMembersByRole: PropTypes.func.isRequired,
  removeRole: PropTypes.func.isRequired
}

UsersByRoleTable.defaultProps = {
  direction: null,
  isLoading: false,
  memberCount: 0,
  members: [],
  sortBy: null
}

export default UsersByRoleTable
